module.exports = __webpack_public_path__ + "img/others_13.afda9598.jpg";